function NoAdvisersAvailableMessage(props){
    return (
		<div className="col-12 adviser-not-available-message">
			<div className="alert alert-info" role="alert">
				<div className="row">
					<div className="col-3 col-md-2 adviser-not-available-icon">
						<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" className="bi bi-exclamation-circle" viewBox="0 0 16 16">
							<title>Sirkel med utropstegn</title>
							<path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
							<path d="M7.002 11a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 4.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 4.995z" />
						</svg>
					</div>
					<div className="col-9 col-md-10">
						<h4 className="alert-heading">
							Vi har dessverre ikke noen tilgjengelige rådgivere akkurat nå
						</h4>
						<p className="alert-message-text">
							Ta gjerne kontakt med kundesenteret vårt, så kan vi hjelpe deg. <br /> 
							Følg denne lenken for å finne <a className="alert-link"href={props.contactCenterUrl} target="_blank">kontaktinformasjonen til kundesenteret</a> vårt. 
						</p>
					</div>
				</div>
			</div>
        </div>)
}
export default NoAdvisersAvailableMessage;